import { render, staticRenderFns } from "./NavbarComp.vue?vue&type=template&id=fc2d01dc&scoped=true"
import script from "./NavbarComp.vue?vue&type=script&lang=js"
export * from "./NavbarComp.vue?vue&type=script&lang=js"
import style0 from "./NavbarComp.vue?vue&type=style&index=0&id=fc2d01dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2d01dc",
  null
  
)

export default component.exports